import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Grid, MenuItem, Typography, Box, Button, Chip } from "@mui/material";
import { useFormContext } from "react-hook-form";

import CustomTextField from "../../../../components/CustomTextField";
import ReactHookFormSelect from "../../../../components/ReactHookFormSelect";
import useTenant from "../../../../hooks/useTenant";
import SearchableAutoComplete from "../../../../components/SearchableAutoComplete";
import useAuth from "../../../../hooks/useAuth";
import CustomSwitch from "../../../../components/CustomSwitch";
import useCafForm from "../../../../hooks/useCafForm";
import CafForm from "../../../caf_form";
import useUser from "../../../../hooks/useUser";
import EditCafForm from "../../../caf_form/edit";

const currentTenantPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const currentCafPayload = {
  filters: [
    {
      fieldName: "isCafUsed",
      fieldValue: false,
      op: "eq",
      dataType: "boolean",
      isJoin: false,
    },
    {
      fieldName: "isCafUsed",
      fieldValue: "null",
      op: "is_null",
      dataType: "boolean",
      condition: "or",
      isJoin: false,
    },
    {
      fieldName: "status",
      fieldValue: "AP",
      op: "eq",
      dataType: "string",
      isJoin: false,
    },
  ],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

function UserFields(props) {
  const { user } = useAuth();
  const { user: editingUser } = useUser();
  const isCafAlreadyLinked = !!(editingUser && editingUser.cafId);
  console.log(user, "useruseruser");
  const { autoSearchTenant, tenantAutoSearchResults } = useTenant();
  const { autoSearchCafForm, cafFormAutoSearchResults, getCafForm, cafForm, resetCAFForm } =
    useCafForm();
  const { validationFields, hideFields, onPendingCafUpdateChange, isEdit } = props;
  const { t } = useTranslation();
  const {
    formState: { errors },
    control,
    watch,
    setValue,
  } = useFormContext();

  const [tenantPayload, setTenantPayload] = useState(currentTenantPayload);
  const [tenantOptions, setTenantOptions] = useState([]);
  const [cafOptions, setCafOptions] = useState([]);
  const [cafPayload, setCafPayload] = useState(currentCafPayload);

  const fetchTenants = async () => {
    await autoSearchTenant(tenantPayload);
  };

  useEffect(() => {
    console.log(user, "user.businessType");
    if (
      user &&
      (user.businessType == "SUPER_ADMIN" ||
        user.businessType == "DISTRIBUTOR" ||
        user.businessType == "MULTI_SERVICE_OPERATOR" ||
        user.businessType == "ADMIN")
    ) {
      fetchTenants();
    }
  }, [user, tenantPayload]);

  useEffect(() => {
    //console.log(ispOptions, "ispOptions", ispAutoSearchResults);
    if (tenantAutoSearchResults.data.length !== 0) {
      const results = [...tenantOptions, ...tenantAutoSearchResults.data];
      const filteredResults = results.filter(
        (value, index, self) => index === self.findIndex((t) => t.value === value.value),
      );
      filteredResults.sort((a, b) => a.label.localeCompare(b.label));
      setTenantOptions(filteredResults);
    }
  }, [tenantAutoSearchResults]);

  useEffect(() => {
    if (cafFormAutoSearchResults.data && cafFormAutoSearchResults.data.length !== 0) {
      const results = [...cafOptions, ...cafFormAutoSearchResults.data];
      const filteredResults = results.filter(
        (value, index, self) => index === self.findIndex((t) => t.value === value.value),
      );
      filteredResults.sort((a, b) => a.label.localeCompare(b.label));
      setCafOptions(filteredResults);
    } else {
      setCafOptions([]);
    }
  }, [cafFormAutoSearchResults]);

  const resetCAFFields = () => {
    setValue("caf", null);
    setCafOptions([]);
    resetCAFDetails1();
  };

  const tenant = watch("tenant");
  const [initialTenantId, setInitialTenantId] = useState(null);
  const [isEditCafModalOpen, setIsEditCafModalOpen] = useState(false);

  // In edit mode: capture the original tenant once so we can compare
  useEffect(() => {
    if (isCafAlreadyLinked && tenant?.value && initialTenantId === null) {
      setInitialTenantId(tenant.value);
    }
  }, [tenant?.value, isCafAlreadyLinked]);

  // True when the franchise has been changed from the original linked value
  const tenantChanged =
    isCafAlreadyLinked &&
    initialTenantId !== null &&
    tenant?.value != null &&
    String(tenant.value) !== String(initialTenantId);

  const fetchCAF = async () => {
    if (!tenant || !tenant.value) {
      return; // ❌ no reset here
    }

    const updatedPayload = {
      ...cafPayload,
      filters: [
        ...cafPayload.filters.filter((f) => f.fieldName !== "tenantId"),
        {
          fieldName: "tenantId",
          fieldValue: tenant.value,
          op: "eq",
          dataType: "int",
          isJoin: true,
        },
      ],
    };

    setCafPayload(updatedPayload);
    await autoSearchCafForm(updatedPayload);
  };

  useEffect(() => {
    fetchCAF();
  }, [tenant]);

  const accountType = watch("accountType");
  const isCAFLinked = watch("isCafLinked");
  const caf = watch("caf");
  const [userNameDisabled, setUserNameDisabled] = useState(false);
  const [fullNameDisabled, setFullNameDisabled] = useState(false);
  const [connectionTypeDisabled, setConnectionTypeDisabled] = useState(false);
  const [mobileNoDisabled, setMobileNoDisabled] = useState(false);
  const [emailIdDisabled, setEmailIdDisabled] = useState(false);

  const fetchCAFDetails = async () => {
    console.log(caf, "cafcafcaf");
    if (caf != null && Object.keys(caf).length !== 0) {
      await getCafForm(caf?.value);
    }
  };

  useEffect(() => {
    fetchCAFDetails();
  }, [caf]);

  const resetCAFDetails = () => {
    setUserNameDisabled(false);
    setFullNameDisabled(false);
    setConnectionTypeDisabled(false);
    setMobileNoDisabled(false);
    setEmailIdDisabled(false);
    setValue("userName", "");
    setValue("fullName", "");
    setValue("mobileNo", "");
    setValue("emailId", "");
    setValue("connectionType", "");
    setValue("doorNo", "");
    setValue("pinCode", null);
    setValue("area", "");
    setValue("city", "");
    setValue("state", "");
    setValue("country", "");
    setValue("plan", null);

    setValue("insDoorNo", "");
    setValue("insPinCode", null);
    setValue("insArea", "");
    setValue("insCity", "");
    setValue("insState", "");
    setValue("insCountry", "");
  };

  useEffect(() => {
    if (cafForm != null && Object.keys(cafForm).length !== 0) {
      setValue("userName", cafForm?.userName);
      setValue("fullName", cafForm?.fullName);
      setValue("mobileNo", cafForm?.mobileNo);
      setValue("emailId", cafForm?.emailId);
      setValue("connectionType", cafForm?.connectionType);
      setValue("doorNo", cafForm?.doorNo);
      setValue("pinCode", {
        label: cafForm?.pinCode,
        value: cafForm?.pinCode,
      });
      setValue("area", cafForm?.area);
      setValue("city", cafForm?.city);
      setValue("state", cafForm?.state);
      setValue("country", cafForm?.country);
      setValue("plan", {
        label: cafForm?.planName,
        value: cafForm?.planId,
      });

      setValue("insDoorNo", cafForm?.insDoorNo);
      setValue("insPinCode", {
        label: cafForm?.insPinCode,
        value: cafForm?.insPinCode,
      });
      setValue("insArea", cafForm?.insArea);
      setValue("insCity", cafForm?.insCity);
      setValue("insState", cafForm?.insState);
      setValue("insCountry", cafForm?.insCountry);

      setUserNameDisabled(true);
      setFullNameDisabled(false);
      setConnectionTypeDisabled(false);
      setMobileNoDisabled(false);
      setEmailIdDisabled(false);
    }
  }, [cafForm]);

  const resetCAFDetails1 = async () => {
    await resetCAFForm();
  };

  const changeTenantEvent = (name, value) => {
    setValue(name, value); // set tenant first
    if (!isCafAlreadyLinked) {
      resetCAFFields(); // only CAF-related reset if not editing an existing linked user
    } else {
      // Mark that CAF update is required before saving user
      if (onPendingCafUpdateChange) onPendingCafUpdateChange(true);
    }
  };

  const changeCAFEvent = (name, value) => {
    if (value == null) {
      resetCAFDetails();
      resetCAFDetails1();
    }

    setValue(name, value);
  };

  const isCreateCAF = watch("createCaf");

  const cafLinkedChange = (value) => {
    if (!value) {
      resetCAFFields();
      resetCAFDetails();
    } else {
      setValue("createCaf", false);
    }
  };

  const createCafChange = (e) => {
    const checked = e?.target ? e.target.checked : e;
    setValue("createCaf", checked);
    if (checked) {
      setValue("isCafLinked", false);
      resetCAFFields();
      resetCAFDetails();
    }
  };

  return (
    <Grid container spacing={12} className="row" pt={8}>
      {user &&
        (user.businessType === "SUPER_ADMIN" ||
          user.businessType == "DISTRIBUTOR" ||
          user.businessType == "MULTI_SERVICE_OPERATOR" ||
          user.businessType == "ADMIN" ||
          user.businessType == "DOT") && (
          <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
            <SearchableAutoComplete
              control={control}
              data={tenantOptions}
              label={t("select_franchise")}
              payload={tenantPayload}
              setPayload={setTenantPayload}
              loading={false}
              name="tenant"
              multiple={false}
              defaultValue={""}
              hasNextPage={false}
              fields={validationFields}
              onChangeEvent={changeTenantEvent}
            />
          </Grid>
        )}
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <Box display="flex" alignItems="center" gap={4}>
          <CustomSwitch
            label={t("is_caf_linked")}
            name="isCafLinked"
            control={control}
            fullWidth
            variant="outlined"
            errors={errors}
            fields={validationFields}
            onChange={cafLinkedChange}
            disabled={isCafAlreadyLinked || isCreateCAF}
          />
          {!isCAFLinked && !isEdit && (
            <CustomSwitch
              label={t("create_caf", "Create CAF")}
              name="createCaf"
              control={control}
              fullWidth
              variant="outlined"
              errors={errors}
              fields={validationFields}
              onChange={createCafChange}
              disabled={isCafAlreadyLinked}
            />
          )}
        </Box>
      </Grid>
      {isCAFLinked && (
        <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
          <Box display="flex" alignItems="center" gap={2} sx={{ width: "100%" }}>
            <Box sx={{ flexGrow: 1 }}>
              <SearchableAutoComplete
                control={control}
                data={cafOptions}
                label={t("select_caf")}
                payload={cafPayload}
                setPayload={setCafPayload}
                loading={false}
                name="caf"
                multiple={false}
                defaultValue={""}
                hasNextPage={false}
                fields={validationFields}
                onChangeEvent={changeCAFEvent}
                disabled={isCafAlreadyLinked && tenant?.value === editingUser?.tenantId}
              />
            </Box>
            {tenantChanged && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => setIsEditCafModalOpen(true)}
                sx={{ whiteSpace: "nowrap" }}
              >
                {t("update_caf", "Update CAF")}
              </Button>
            )}
          </Box>
          {cafOptions.length === 0 && (
            <Typography variant="caption" color="textSecondary" sx={{ mt: 0.5, display: "block" }}>
              No approved/unused CAF IDs exist for this Franchise.
            </Typography>
          )}
        </Grid>
      )}

      {isEditCafModalOpen && (
        <EditCafForm
          isModal={true}
          open={isEditCafModalOpen}
          cafId={watch("caf")?.value || user?.cafId}
          newTenant={tenant}
          onSuccess={async (updatedCaf) => {
            await fetchCAF();
            if (updatedCaf && updatedCaf.cafId) {
              setValue("caf", {
                value: updatedCaf.cafId,
                label: updatedCaf.cafNumber,
              });
            }
            if (tenant?.value) {
              setInitialTenantId(tenant.value);
            }
            // CAF has been updated — allow form save
            if (onPendingCafUpdateChange) onPendingCafUpdateChange(false);
          }}
          onCloseModal={() => setIsEditCafModalOpen(false)}
        />
      )}
      {hideFields && !hideFields.includes("accountType") && (
        <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
          <ReactHookFormSelect
            name="accountType"
            label={t("account_type")}
            control={control}
            fullWidth
            variant="outlined"
            errors={errors}
            fields={validationFields}
          >
            <MenuItem value={"NORMAL_USER"}>Normal User</MenuItem>
            <MenuItem value={"MAC_USER"}>MAC User</MenuItem>
          </ReactHookFormSelect>
        </Grid>
      )}
      {hideFields && !hideFields.includes("userName") && (
        <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
          <CustomTextField
            label={t("user_name")}
            name="userName"
            control={control}
            fullWidth
            variant="outlined"
            errors={errors}
            fields={validationFields}
            disabled={userNameDisabled}
          />
        </Grid>
      )}
      {hideFields && !hideFields.includes("mac") && accountType && accountType == "MAC_USER" && (
        <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
          <CustomTextField
            label={t("mac")}
            name="mac"
            control={control}
            fullWidth
            variant="outlined"
            errors={errors}
            fields={validationFields}
          />
        </Grid>
      )}
      {hideFields && !hideFields.includes("routerPassword") && (
        <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
          <CustomTextField
            label={t("router_password")}
            name="routerPassword"
            control={control}
            fullWidth
            variant="outlined"
            errors={errors}
            fields={validationFields}
          />
        </Grid>
      )}
      {hideFields && !hideFields.includes("confirmRouterPassword") && (
        <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
          <CustomTextField
            label={t("confirm_router_password")}
            name="confirmRouterPassword"
            control={control}
            fullWidth
            variant="outlined"
            errors={errors}
            fields={validationFields}
          />
        </Grid>
      )}
      {hideFields && !hideFields.includes("appPassword") && (
        <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
          <CustomTextField
            label={t("app_password")}
            name="appPassword"
            control={control}
            fullWidth
            variant="outlined"
            errors={errors}
            fields={validationFields}
          />
        </Grid>
      )}
      {hideFields && !hideFields.includes("confirmAppPassword") && (
        <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
          <CustomTextField
            label={t("confirm_app_password")}
            name="confirmAppPassword"
            control={control}
            fullWidth
            variant="outlined"
            errors={errors}
            fields={validationFields}
          />
        </Grid>
      )}
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <CustomTextField
          label={t("Full Name")}
          name="fullName"
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
          disabled={fullNameDisabled}
        />
      </Grid>
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <CustomTextField
          label={t("Mobile Number")}
          name="mobileNo"
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
          disabled={mobileNoDisabled}
        />
      </Grid>
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <CustomTextField
          label={t("Email Id")}
          name="emailId"
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
          disabled={emailIdDisabled}
        />
      </Grid>
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <CustomTextField
          label={t("GST No")}
          name="gstNo"
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
        />
      </Grid>
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <ReactHookFormSelect
          name="userServiceType"
          label={t("user_service_type")}
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
        >
          <MenuItem value={"INTERNET"}>Internet</MenuItem>
          <MenuItem value={"COMBO"}>Combo</MenuItem>
          <MenuItem value={"INTERNET_OTT"}>Internet & OTT</MenuItem>
        </ReactHookFormSelect>
      </Grid>
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <ReactHookFormSelect
          name="connectionType"
          label={t("connection_type")}
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
          disabled={connectionTypeDisabled}
        >
          <MenuItem value={"HOME_USER"}>Home User</MenuItem>
          <MenuItem value={"BUSINESS_USER"}>Business User</MenuItem>
        </ReactHookFormSelect>
      </Grid>
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <ReactHookFormSelect
          name="status"
          label={t("Status")}
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
        >
          <MenuItem value={"ACTIVE"}>ACTIVE</MenuItem>
          <MenuItem value={"INACTIVE"}>INACTIVE</MenuItem>
        </ReactHookFormSelect>
      </Grid>
    </Grid>
  );
}

export default UserFields;
